import { useRecoilValue } from 'recoil';
import { levelStateAtom } from '../recoil/atoms';

export function useAnimateLevel() {
  const levelState = useRecoilValue(levelStateAtom);

  return {
    displayed_level_value: levelState.currentDisplayLevelForPulse,
    is_changing_value: levelState.isLevelChanging,
    change_direction_value: levelState.levelChangeDirection,
  };
}

